import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { getSiteUrl } from '../config/siteUrl';

/**
 * Sayfa başlığı, açıklama, canonical, Open Graph ve Twitter kartları.
 * @param {{
 *   title: string,
 *   description?: string,
 *   noindex?: boolean,
 *   ogImage?: string,
 * }} props
 */
export function PageSeo({ title, description, noindex, ogImage }) {
    const { pathname, search } = useLocation();
    const { t } = useTranslation();
    const siteUrl = getSiteUrl();
    const canonical = siteUrl ? `${siteUrl}${pathname}${search}` : '';
    const metaDesc = description ?? t('seo.defaultDescription');
    const siteName = t('seo.siteName');
    const defaultOg = siteUrl ? `${siteUrl}/logo512.png` : '';
    const image = ogImage || defaultOg;

    return (
        <Helmet prioritizeSeoTags>
            <title>{title}</title>
            <meta name="description" content={metaDesc} />
            <meta
                name="robots"
                content={noindex ? 'noindex, nofollow' : 'index, follow'}
            />
            {canonical ? <link rel="canonical" href={canonical} /> : null}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={metaDesc} />
            {canonical ? (
                <meta property="og:url" content={canonical} />
            ) : null}
            {image ? <meta property="og:image" content={image} /> : null}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={metaDesc} />
            {image ? <meta name="twitter:image" content={image} /> : null}
        </Helmet>
    );
}
